import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, Navigate, useLocation } from "react-router-dom";
import axios from "axios";
import { Alertmessage } from "../../widgets";
import {
  FaBars,
  FaCheckCircle,
  FaChevronDown,
  FaTimes,
  FaUsers,
  FaSync,
  FaExclamationCircle,
  FaClipboardCheck,
  FaMoneyBillWave,
  FaFileInvoiceDollar,
  FaCalendarAlt,
} from "react-icons/fa";
import "./Pjc_dashboard.css";
// Reuse the beautiful layout styling of the PJC system

axios.defaults.withCredentials = true;

const ADMIN_NAVIGATION = [
  { label: "Pending Approvals", icon: FaClipboardCheck },
  { label: "All Transactions", icon: FaFileInvoiceDollar },
  { label: "Alumni / Users", icon: FaUsers },
  {label:"User Transactions",icon:FaCalendarAlt},
  //{ label: "Payment Plans", icon: FaFileInvoiceDollar },
  
  { label: "Manual Entry Transactions", icon: FaMoneyBillWave },
  { label: "Alumni Payment Entry", icon: FaMoneyBillWave },
];

const STATUS_FILTER_OPTIONS = ["All", "Pending", "Approved", "Rejected"];

// Fixed fund-type options requested by client (Own / CSR), plus "All".
// Any additional fund_type values found in the actual data are merged in dynamically below.
const DEFAULT_FUND_TYPE_OPTIONS = ["OWN", "CSR", "INSTITUTION"];

// Fixed branch/department options for the Branch filter dropdown.
const BRANCH_OPTIONS = ["CSE", "ECE", "EEE", "CIVIL", "MECH", "MCA", "Others"];

const DEBUG_LINKING = false;

const formatMoney = (value) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(value || 0);

const formatDate = (value) => {
  if (!value) return "-";
  const d = new Date(value);
  if (isNaN(d.getTime())) return value;
  return d.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

// Converts date to yyyy-mm-dd using local timezone
const toDateKey = (value) => {
  if (!value) return null;
  const d = new Date(value);
  if (isNaN(d.getTime())) return null;
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// Pulls the first non-empty value out of an object across a list of possible
// key names. Used so we don't silently break every time the backend renames
// a field or nests it differently (e.g. branch vs branch_name vs Branch).
const pick = (obj, keys) => {
  if (!obj) return null;
  for (const k of keys) {
    const v = obj[k];
    if (v !== undefined && v !== null && v !== "") return v;
  }
  return null;
};

// Normalizes a string for loose matching (trim + lowercase + collapse spaces).
const normStr = (v) => (v === undefined || v === null ? "" : String(v).trim().toLowerCase());

// Normalizes a phone number for matching by stripping everything but digits
// (so "+91 553-366-3377" and "915533663377" are treated as equal).
const normPhone = (v) => (v === undefined || v === null ? "" : String(v).replace(/\D/g, ""));

const USER_ID_KEYS = [
  "user_id",
  "alumni_id",
  "userId",
  "alumniId",
  "alumni_ref",
  "alumniRef",
  "user",
  "alumni",
];

const ALUMNI_PK_KEYS = ["id", "_id", "user_id", "alumni_id", "userId"];

const BRANCH_KEYS = ["branch", "branch_name", "branchName", "department", "dept"];
const BATCH_KEYS = ["batch", "batch_no", "batchNo", "batch_year", "year"];
const FUND_TYPE_KEYS = ["fund_type", "fundType", "fund", "type"];


const extractId = (val) => {
  if (val === undefined || val === null || val === "") return null;
  if (typeof val === "object") {
    for (const k of ALUMNI_PK_KEYS) {
      const inner = val[k];
      if (inner !== undefined && inner !== null && inner !== "") return inner;
    }
    return null;
  }
  return val;
};

const AdminDashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [authStatus, setAuthStatus] = useState("loading");
  const [currentUser, setCurrentUser] = useState(null);

  // UI Navigation State
  const [mobileOpen, setMobileOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [activeItem, setActiveItem] = useState("Pending Approvals");
  const [alertMsg, setAlertMsg] = useState("");
  const [rejectPrompt, setRejectPrompt] = useState(null);
  const [confirmModal, setConfirmModal] = useState(null);

  // Data Loading & Error States
  const [loadingData, setLoadingData] = useState(true);
  const [dataError, setDataError] = useState("");
  const [pendingApprovals, setPendingApprovals] = useState([]);
  const [allTransactions, setAllTransactions] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  

  // Filter State (All Transactions panel)
  const [statusFilter, setStatusFilter] = useState("All");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // Batch-wise / Branch-wise / Fund Type (Own / CSR) filters
  const [batchFilter, setBatchFilter] = useState("All");
  const [branchFilter, setBranchFilter] = useState("All");
  const [fundTypeFilter, setFundTypeFilter] = useState("All");
 
const [userStatusFilter, setUserStatusFilter] = useState("All");
const [userBatchFilter, setUserBatchFilter] = useState("All");
const [userBranchFilter, setUserBranchFilter] = useState("All");
const [userFundTypeFilter, setUserFundTypeFilter] = useState("All");
const [userStartDate, setUserStartDate] = useState("");
const [userEndDate, setUserEndDate] = useState("");
const [userTransactionsPage, setUserTransactionsPage] = useState(1);

const [userTransactionsPagination, setUserTransactionsPagination] =
  useState({
    page: 1,
    limit: 15,
    totalRecords: 0,
    totalPages: 0,
  });

const [userTransactionsTotals, setUserTransactionsTotals] = useState({
  totalAmount: 0,
});

const [userTransactionsPageTotals, setUserTransactionsPageTotals] =
  useState({
    pageRecords: 0,
    pageTotalAmount: 0,
  });

const userTransactionsTotalPages =
  userTransactionsPagination.totalPages || 0;

  const [registeredAlumni, setRegisteredAlumni] = useState([]);
  const [alumniPage, setAlumniPage] = useState(1);

const [alumniPagination, setAlumniPagination] = useState({
  page: 1,
  limit: 15,
  totalRecords: 0,
  totalPages: 0
});

const alumniTotalPages =
  alumniPagination.totalPages || 0;
  const [totalPledged, setTotalPledged] = useState(0);
  const [userAlumniDetails, setUserAlumniDetails] = useState([]);
  
  const [manualEntryDetails, setManualEntryDetails] = useState([]);
  const [manualEntryPage, setManualEntryPage] = useState(1);

const [manualEntryPagination, setManualEntryPagination] = useState({
  page: 1,
  limit: 15,
  totalRecords: 0,
  totalPages: 0
});

const [manualEntryTotals, setManualEntryTotals] = useState({
  totalAmount: 0
});

const [manualEntryPageTotals, setManualEntryPageTotals] = useState({
  pageRecords: 0,
  pageTotalAmount: 0
});
const manualEntryTotalPages =
  manualEntryPagination.totalPages || 0;
  const RECORDS_PER_PAGE = 15;
const [allTransactionsPage, setAllTransactionsPage] = useState(1);
const [allTransactionsPageTotals, setAllTransactionsPageTotals] =
    useState({
        pageRecords: 0,
        pageTotalAmount: 0
    });
const [allTransactionsPagination, setAllTransactionsPagination] =
    useState({
        page: 1,
        limit: 15,
        totalRecords: 0,
        totalPages: 0
    });

const [allTransactionsTotals, setAllTransactionsTotals] =
    useState({
        totalAmount: 0
    });

  const isSuperAdmin = currentUser?.role?.toLowerCase() === "superadmin";
  useEffect(() => {
    let isMounted = true;

    const verifySession = async () => {
      try {
        const res = await axios.get("/backend/admin/login_verification");
        if (isMounted && res.data && res.data.token_status === "okay") {
          setCurrentUser(res.data.user || null);
          setAuthStatus("authenticated");
          return;
        }
      } catch (err) {
        console.log("Session verification failed:", err?.message);
      }

      if (isMounted) {
        setAuthStatus("unauthenticated");
      }
    };

    verifySession();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (location.state?.activeItem) {
      setActiveItem(location.state.activeItem);
    }
  }, [location.state]);

  useEffect(() => {
    if (authStatus !== "authenticated") return;
    fetchAdminData();
  
    
  }, [authStatus,alumniPage]);
  useEffect(() => {
  if (authStatus !== "authenticated") return;

  fetchUserAlumniData();
}, [
  authStatus,
  userTransactionsPage,
  userStatusFilter,
  userBatchFilter,
  userBranchFilter,
  userFundTypeFilter,
  userStartDate,
  userEndDate,
]);
useEffect(() => {
  setUserTransactionsPage(1);
}, [
  userStatusFilter,
  userBatchFilter,
  userBranchFilter,
  userFundTypeFilter,
  userStartDate,
  userEndDate,
]);
  useEffect(() => {
  if (authStatus !== "authenticated") return;

  fetchManualEntryData();
}, [authStatus, manualEntryPage]);
useEffect(() => {
  setAllTransactionsPage(1);
}, [
  searchQuery,
  statusFilter,
  startDate,
  endDate,
  batchFilter,
  branchFilter,
  fundTypeFilter,
]);

  const fetchAdminData = async () => {
  
    setLoadingData(true);
    setDataError("");
    try {
      const [pendingRes, approvedRes, rejectedRes, alumniRes, dashboardRes] = await Promise.allSettled([
        axios.get("/backend/admin/transactions/pending"),
        axios.post("/backend/admin/transactions/approved"),
        axios.post("/backend/admin/transactions/rejected"),
        axios.get("/backend/admin/alumni", {
          params: {
            page: alumniPage,
            limit: RECORDS_PER_PAGE
          }
        }),
        axios.get("/backend/admin/dashboard-stats"),
        

      ]);

      let pending = [];
      if (pendingRes.status === "fulfilled" && pendingRes.value.data?.pending) {
        pending = pendingRes.value.data.pending;
        setPendingApprovals(pending);
      } else {
        setPendingApprovals([]);
      }

      let approved = [];
      if (approvedRes.status === "fulfilled" && approvedRes.value.data?.approved) {
        approved = approvedRes.value.data.approved;
      }

      let rejected = [];
      if (rejectedRes.status === "fulfilled" && rejectedRes.value.data?.rejected) {
        rejected = rejectedRes.value.data.rejected;
      }
      
      const normalizeTransaction = (t, status) => ({
        ...t,

        approval_status: status,

        reference: t.reference || t.transaction_reference,
        amount: Number(t.amount || t.amount_paid || 0),
        method: t.method || t.payment_mode,
        date: t.date || t.payment_date,

        // Normalize the alumni-link id so it works regardless of which key name
        // the backend actually sends for a given record (used to join against
        // registeredAlumni below to pull branch / fund_type).
        // FIX: run the raw picked value through extractId() in case the field
        // is a nested alumni object rather than a plain id.
        user_id: extractId(pick(t, USER_ID_KEYS)),

        // Extra fields kept around purely to power the fallback-matching
        // strategy in enrichedTransactions below (email / phone / name),
        // in case the id-based join above doesn't find a match.
        email: t.email || t.alumni_email,
        phone: t.phone || t.alumni_phone || t.mobile,

        // Normalize batch / branch / fund_type so filters work even if a record
        // already happens to carry these directly.
        batch: pick(t, BATCH_KEYS),
        branch: pick(t, BRANCH_KEYS),
        fund_type: pick(t, FUND_TYPE_KEYS),

        source: t.source || "transactions",
      });

     
     
      //console.log("Combined Transactions:", combined);

      let alumniList = [];

if (alumniRes.status === "fulfilled" && alumniRes.value.data?.alumni) {
  alumniList = alumniRes.value.data.alumni;

  setRegisteredAlumni(alumniList);

  if (alumniRes.value.data?.pagination) {
    setAlumniPagination(alumniRes.value.data.pagination);
  }
} else {
  setRegisteredAlumni([]);

  setAlumniPagination({
    page: 1,
    limit: RECORDS_PER_PAGE,
    totalRecords: 0,
    totalPages: 0
  });
}

      if (DEBUG_LINKING) {
        // eslint-disable-next-line no-console
        console.log("[DEBUG_LINKING] sample raw transaction:", pending[0] || approved[0] || rejected[0]);
        // eslint-disable-next-line no-console
        console.log("[DEBUG_LINKING] sample raw alumni record:", alumniList[0]);
        // eslint-disable-next-line no-console
        console.log(
          "[DEBUG_LINKING] resolved user_id on first transaction:",
          extractId(pick(pending[0] || approved[0] || rejected[0], USER_ID_KEYS))
        );
        // eslint-disable-next-line no-console
        console.log(
          "[DEBUG_LINKING] resolved branch on first alumni record:",
          pick(alumniList[0], BRANCH_KEYS)
        );
      }

      if (
  dashboardRes.status === "fulfilled" &&
  dashboardRes.value.data.success
) {
  setTotalPledged(
    Number(dashboardRes.value.data.totalPledged || 0)
  );

  setSummaryApprovedTotal(
    Number(dashboardRes.value.data.totalFundCollections || 0)
  );
} else {
  setTotalPledged(0);
  setSummaryApprovedTotal(0);
}
    } catch (err) {
      console.error("Error loading admin records:", err);
      setDataError("Failed to fetch administrative records.");
    } finally {
      setLoadingData(false);
    }
  };
 
const fetchUserAlumniData = async () => {
  try {
    const response = await axios.get(
      "/backend/admin/transactions/user",
      {
        params: {
          page: userTransactionsPage,
          limit: 15,

          status: userStatusFilter,
          batch: userBatchFilter,
          branch: userBranchFilter,
          fundType: userFundTypeFilter,

          startDate: userStartDate,
          endDate: userEndDate,
        },
      }
    );

    if (response.data?.success) {
      setUserAlumniDetails(
        response.data.transactions || []
      );

      setUserTransactionsPagination(
        response.data.pagination || {
          page: 1,
          limit: 15,
          totalRecords: 0,
          totalPages: 0,
        }
      );

      setUserTransactionsTotals(
        response.data.totals || {
          totalAmount: 0,
        }
      );

      setUserTransactionsPageTotals(
        response.data.pageTotals || {
          pageRecords: 0,
          pageTotalAmount: 0,
        }
      );
    }
  } catch (error) {
    console.error(
      "Failed to fetch user alumni details:",
      error
    );

    setUserAlumniDetails([]);
  }
};


const fetchManualEntryData = async () => {
  try {
    const response = await axios.get(
      "/backend/admin/transactions/manual-entry",
      {
        params: {
          page: manualEntryPage,
          limit: 15
        }
      }
    );

    if (response.data?.success) {
      setManualEntryDetails(response.data.transactions || []);

      setManualEntryPagination(
        response.data.pagination || {
          page: 1,
          limit: 15,
          totalRecords: 0,
          totalPages: 0
        }
      );

      setManualEntryTotals(
        response.data.totals || {
          totalAmount: 0
        }
      );

      setManualEntryPageTotals(
        response.data.pageTotals || {
          pageRecords: 0,
          pageTotalAmount: 0
        }
      );
    }
  } catch (error) {
    console.error("Failed to fetch manual entry transactions:", error);
    setManualEntryDetails([]);
  }
};
  const handleLogout = async () => {
    try {
      await axios.post("/backend/admin/logout", {});
    } catch { }
    setAuthStatus("unauthenticated");
    navigate("/alumni-login", { replace: true, state: { loggedOut: true } });
  };

  const handleAdminApprove = (item) => {
    setConfirmModal({
      message: "Are you sure you want to approve this transaction?",
      onConfirm: async () => {
        setConfirmModal(null);
        try {
          await axios.post(`/backend/admin/transactions/${item.id}/approve`);
          setAlertMsg(`Transaction ${item.transaction_reference || item.reference || ""} approved successfully!`);
          fetchAdminData();
        } catch (err) {
          console.error("Approve failed:", err);
          setAlertMsg(err.response?.data?.error || "Failed to approve transaction.");
        }
      },
    });
  };

  const openRejectPrompt = (item) => {
    setRejectPrompt({
      item,
      reasonValue: "",
    });
  };

  const handleAdminReject = async () => {
    if (!rejectPrompt) return;
    const { item, reasonValue } = rejectPrompt;
    if (!reasonValue || !reasonValue.trim()) return;

    setRejectPrompt(null);
    try {
      await axios.post(`/backend/admin/transactions/${item.id}/reject`, { reason: reasonValue.trim() });
      setAlertMsg(`Transaction ${item.transaction_reference || item.reference || ""} rejected.`);
      fetchAdminData();
    } catch (err) {
      console.error("Reject failed:", err);
      setAlertMsg(err.response?.data?.error || "Failed to reject transaction.");
    }
  };
  const fetchAllTransactionsPage = async () => {
    try {
        const params = {
            page: allTransactionsPage,
            limit: RECORDS_PER_PAGE,
            search: searchQuery,
            status: statusFilter,
            batch: batchFilter,
            branch: branchFilter,
            fundType: fundTypeFilter,
            startDate,
            endDate
        };

        const response = await axios.get(
            "/backend/admin/transactions/all",
            { params }
        );

        if (response.data.success) {
          setAllTransactions(
  (response.data.transactions || []).map((t) => ({
    ...t,
    reference: t.transaction_reference || t.reference,
    amount: Number(t.amount_paid || t.amount || 0),
    method: t.payment_mode || t.method,
    date: t.payment_date || t.date,
    approval_status: (
      t.approval_status || "PENDING"
    ).toUpperCase(),
  }))
);

            setAllTransactionsPagination(
                response.data.pagination
            );

            setAllTransactionsTotals(
                response.data.totals
            );
            setAllTransactionsPageTotals(
    response.data.pageTotals
);
        }

    } catch (error) {
        console.error(
            "Failed to fetch all transactions:",
            error
        );
    }
};
useEffect(() => {
  if (authStatus !== "authenticated") return;

  fetchAllTransactionsPage();
}, [
  authStatus,
  allTransactionsPage,
  searchQuery,
  statusFilter,
  batchFilter,
  branchFilter,
  fundTypeFilter,
  startDate,
  endDate
]);

  // Map alumni by id so transactions can be enriched with branch / fund_type,
  // since those fields live on the alumni record, not the transaction record.
  // Keys off every plausible primary-key field name so the join still works
  // even if the backend uses _id (e.g. Mongo) instead of id.
  const alumniById = useMemo(() => {
    const map = new Map();
    registeredAlumni.forEach((usr) => {
      ALUMNI_PK_KEYS.forEach((key) => {
        const val = usr[key];
        if (val !== undefined && val !== null && val !== "") {
          map.set(String(val), usr);
        }
      });
    });
    return map;
  }, [registeredAlumni]);

  // FIX: Backup lookup maps used only when the id-based join above can't find
  // a match (wrong/renamed id field, mismatched types, etc). Built from
  // fields that reliably appear on both the alumni record and the
  // transaction record: email, phone, and full name.
  const alumniByEmail = useMemo(() => {
    const map = new Map();
    registeredAlumni.forEach((usr) => {
      const key = normStr(usr.email);
      if (key) map.set(key, usr);
    });
    return map;
  }, [registeredAlumni]);

  const alumniByPhone = useMemo(() => {
    const map = new Map();
    registeredAlumni.forEach((usr) => {
      const key = normPhone(usr.phone);
      if (key) map.set(key, usr);
    });
    return map;
  }, [registeredAlumni]);

  const alumniByName = useMemo(() => {
    const map = new Map();
    registeredAlumni.forEach((usr) => {
      const key = normStr(usr.fullname);
      // Only keep names that are unambiguous (unique) to avoid mismatching
      // two different people who happen to share the exact same name.
      if (key) map.set(key, map.has(key) ? null : usr);
    });
    return map;
  }, [registeredAlumni]);

  // Transactions enriched with branch / fund_type looked up from the matching
  // alumni record. Tries the id-based join first (fast, precise), then falls
  // back to email -> phone -> exact full-name match if the id link is missing
  // or doesn't resolve. Never throws even if every field is missing; in that
  // case branch/batch/fund_type simply stay null and the record just won't
  // show up under a specific branch/batch/fund-type filter (but will still
  // show up under "All").
  const enrichedTransactions = useMemo(() => {
    const unmatched = [];

    const result = allTransactions.map((t) => {
      let matchedAlumni = null;

      if (t.user_id !== null && t.user_id !== undefined) {
        matchedAlumni = alumniById.get(String(t.user_id)) || null;
      }

      if (!matchedAlumni && t.email) {
        matchedAlumni = alumniByEmail.get(normStr(t.email)) || null;
      }

      if (!matchedAlumni && t.phone) {
        matchedAlumni = alumniByPhone.get(normPhone(t.phone)) || null;
      }

      if (!matchedAlumni) {
        const nameKey = normStr(t.fullname || t.donor_name);
        if (nameKey) matchedAlumni = alumniByName.get(nameKey) || null;
      }

      if (DEBUG_LINKING && !matchedAlumni) {
        unmatched.push({ id: t.id, reference: t.reference, user_id: t.user_id, email: t.email, phone: t.phone, name: t.fullname || t.donor_name });
      }

      return {
        ...t,
        branch: t.branch || pick(matchedAlumni, BRANCH_KEYS),
        fund_type: t.fund_type || pick(matchedAlumni, FUND_TYPE_KEYS),
        batch: t.batch || pick(matchedAlumni, BATCH_KEYS),
      };
    });

    if (DEBUG_LINKING && unmatched.length) {
      // eslint-disable-next-line no-console
      console.log(`[DEBUG_LINKING] ${unmatched.length} transaction(s) could not be matched to any alumni record:`, unmatched);
    }

    return result;
  }, [allTransactions, alumniById, alumniByEmail, alumniByPhone, alumniByName]);

  // Applies ONLY the date-range filter (not status / search) on top of enrichedTransactions.
  // This is the source used to power the 3 summary cards, so the cards always show a
  // full Pending / Approved / Total breakdown for whatever date range is selected,
  // independent of which status the table itself is currently filtered to.
  const dateFilteredTransactions = useMemo(() => {
    let result = enrichedTransactions;

    if (startDate) {
      result = result.filter((t) => {
        const txDate = toDateKey(t.date);
        if (!txDate) return false;

        if (!endDate) {
          return txDate >= startDate;
        }

        return txDate >= startDate && txDate <= endDate;
      });
    } else if (endDate) {
      result = result.filter((t) => {
        const txDate = toDateKey(t.payment_date || t.date);
        return txDate && txDate <= endDate;
      });
    }

    return result;
  }, [enrichedTransactions, startDate, endDate]);

  // Summary card metrics — recalculated live from dateFilteredTransactions.
  const summaryPendingCount = useMemo(
    () =>
      dateFilteredTransactions.filter(
        (t) => (t.approval_status || "").toUpperCase() === "PENDING"
      ).length,
    [dateFilteredTransactions]
  );

  const summaryApprovedCount = useMemo(
    () =>
      dateFilteredTransactions.filter(
        (t) => (t.approval_status || "").toUpperCase() === "APPROVED"
      ).length,
    [dateFilteredTransactions]
  );

  // const summaryApprovedTotal = useMemo(
  //   () =>
  //     dateFilteredTransactions
  //       .filter((t) => (t.approval_status || "").toUpperCase() === "APPROVED")
  //       .reduce((sum, t) => sum + Number(t.amount || t.amount_paid || 0), 0),
  //   [dateFilteredTransactions]
  // );
  const [summaryApprovedTotal, setSummaryApprovedTotal] = useState(0);

  // Batch filter options: every year from 1967 up to the current year,
  // shown newest-first, so the dropdown always has a full, predictable list
  // regardless of what batch values actually exist in the data.
  const batchOptions = useMemo(() => {
    const currentYear = new Date().getFullYear();
    return Array.from(
      { length: currentYear - 1956 + 1 },
      (_, index) => currentYear - index
    );
  }, []);

  // Branch filter options: fixed department list requested by client, so the
  // dropdown always shows these branches regardless of what's in the data.
  const branchOptions = BRANCH_OPTIONS;

  const fundTypeOptions = useMemo(() => {
    const set = new Set(DEFAULT_FUND_TYPE_OPTIONS);
    enrichedTransactions.forEach((t) => {
      if (t.fund_type) set.add(String(t.fund_type));
    });
    return Array.from(set);
  }, [enrichedTransactions]);

  const filteredAllTransactions = useMemo(() => {
    let result = enrichedTransactions;

    // Search filter (name, reference, batch, payment method)
    if (searchQuery.trim()) {
      const q = searchQuery.trim().toLowerCase();
      result = result.filter(
        (t) =>
          (t.fullname || t.donor_name || "").toLowerCase().includes(q) ||
          (t.reference || t.transaction_reference || "").toLowerCase().includes(q) ||
          (t.batch && t.batch.toString().toLowerCase().includes(q)) ||
          (t.payment_mode || t.method || "").toLowerCase().includes(q)
      );
    }

    // Status filter
    if (statusFilter !== "All") {
      result = result.filter(
        (t) => (t.approval_status || "PENDING").toUpperCase() === statusFilter.toUpperCase()
      );
    }

    // Batch filter
    if (batchFilter !== "All") {
      result = result.filter((t) => String(t.batch || "") === String(batchFilter));
    }

    // Branch filter
    if (branchFilter !== "All") {
      result = result.filter(
        (t) => String(t.branch || "").toLowerCase() === branchFilter.toLowerCase()
      );
    }

    // Fund Type filter (Own / CSR / etc.)
    if (fundTypeFilter !== "All") {
      result = result.filter(
        (t) => (t.fund_type || "").toLowerCase() === fundTypeFilter.toLowerCase()
      );
    }

    // Date range filter
    if (startDate) {
      result = result.filter((t) => {
        const txDate = toDateKey(t.payment_date || t.date);
        if (!txDate) return false;

        if (!endDate) {
          return txDate >= startDate;
        }

        return txDate >= startDate && txDate <= endDate;
      });
    } else if (endDate) {
      result = result.filter((t) => {
        const txDate = toDateKey(t.payment_date || t.date);
        return txDate && txDate <= endDate;
      });
    }

    result = [...result].sort((a, b) => {
      const dateA = new Date(a.payment_date || a.date || 0);
      const dateB = new Date(b.payment_date || b.date || 0);
      return dateB - dateA;
    });

    return result;
  }, [
    enrichedTransactions,
    searchQuery,
    statusFilter,
    startDate,
    endDate,
    batchFilter,
    branchFilter,
    fundTypeFilter,
  ]);
 const allTransactionsTotalPages =
  allTransactionsPagination.totalPages || 0;

const paginatedAllTransactions = allTransactions;

  // Totals for whatever is currently showing in the All Transactions table
  // (respects every active filter: search, status, batch, branch, fund type, date range).
 


 
  const filteredTotals = {
  count: allTransactionsPagination.totalRecords || 0,
  amount: allTransactionsTotals.totalAmount || 0,
};

  const clearDateFilters = () => {
    setStartDate("");
    setEndDate("");
  };

  const clearAllFilters = () => {
    setSearchQuery("");
    setStatusFilter("All");
    setStartDate("");
    setEndDate("");
    setBatchFilter("All");
    setBranchFilter("All");
    setFundTypeFilter("All");
  };

  const hasActiveFilters =
    searchQuery ||
    statusFilter !== "All" ||
    startDate ||
    endDate ||
    batchFilter !== "All" ||
    branchFilter !== "All" ||
    fundTypeFilter !== "All";

  if (authStatus === "loading") {
    return (
      <div className="pjc-loading-screen">
        <div className="pjc-spinner" />
        <p>Loading Admin Portal...</p>
      </div>
    );
  }

  if (authStatus === "unauthenticated") {
    return <Navigate to="/alumni-login" replace />;
  }

  return (
    <div className="pjc-dashboard-page">
      {mobileOpen && (
        <button
          className="pjc-sidebar-backdrop"
          onClick={() => setMobileOpen(false)}
          aria-label="Close navigation sidebar"
        />
      )}

      <aside className={`pjc-sidebar ${sidebarCollapsed ? "is-collapsed" : ""} ${mobileOpen ? "is-open" : ""}`}>
        <div className="pjc-brand">
          <div className="pjc-brand-mark">P</div>
          <div className="pjc-brand-text">
            <span>PJC Fund</span>
            <small>Admin View</small>
          </div>
          <button className="pjc-close-sidebar" onClick={() => setMobileOpen(false)} aria-label="Close navigation">
            <FaTimes />
          </button>
        </div>

        <p className="pjc-sidebar-label">MANAGEMENT</p>
        <nav className="pjc-nav" aria-label="Dashboard navigation">
          {ADMIN_NAVIGATION.filter(
            (item) => item.label !== "Alumni Payment Entry" || isSuperAdmin
          ).map(({ label, icon: Icon }) => (
            <button
              key={label}
              className={`pjc-nav-link ${activeItem === label ? "active" : ""}`}
              onClick={() => {
                if (label === "Alumni Payment Entry") {
                  if (!isSuperAdmin) {
                    setAlertMsg("Only Super Admin can access Alumni Payment Entry.");
                    return;
                  }

                  navigate("/payment-entry");
                } else {
                  setActiveItem(label);
                }

                setMobileOpen(false);
              }}
              title={label}
            >
              <Icon aria-hidden="true" />
              <span>{label}</span>
            </button>
          ))}
        </nav>

        {/* <button
          className="pjc-collapse-button"
          onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
          aria-label="Toggle sidebar width"
        >
          {sidebarCollapsed ? <FaChevronRight /> : <FaChevronLeft />}
          <span>Collapse Sidebar</span>
        </button> */}
      </aside>


      <main className="pjc-dashboard-content">


        <header className="pjc-topbar">

          <div className="pjc-topbar-title-group">

            <button className="pjc-menu-button" onClick={() => setMobileOpen(true)} aria-label="Open sidebar menu">
              <FaBars />
            </button>
            <div className="pjc-brand-logo-wrapper">
              <img
                src="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Pjc+module/pjc+logo+(1).webp"
                alt="PJC Fund Logo"
                className="pjc-brand-logo"
              />
            </div>
            <div>
              <p className="pjc-eyebrow">ACGCET ALUMNI FUND SYSTEM</p>
              <h1>Admin Portal</h1>
            </div>
          </div>

          <div className="pjc-topbar-actions">
            <div className="pjc-profile-badge">
              <span className="pjc-avatar">
                {currentUser?.username ? currentUser.username.substring(0, 2).toUpperCase() : "AD"}
              </span>
              <div className="pjc-profile-meta">
                <strong>{currentUser?.username || "Administrator"}</strong>
                <small>PJC Administrator</small>
              </div>
            </div>

            <button className="pjc-action-btn secondary" onClick={handleLogout} title="Logout of session">
              Logout
            </button>
          </div>
        </header>

        <div className="pjc-dashboard-body">
          {dataError && (
            <div className="pjc-alert warning">
              <FaExclamationCircle /> {dataError}
            </div>
          )}

          <section className="pjc-dashboard-section">
            <div className="pjc-summary-grid pjc-admin-summary-grid">
              <article className="pjc-summary-card">
                <div className="pjc-summary-icon orange">
                  <FaClipboardCheck />
                </div>
                <div>
                  <p>Pending Approvals</p>
                  <h3>{summaryPendingCount}</h3>
                  <small>Requires Verification</small>
                </div>
              </article>

              <article className="pjc-summary-card">
                <div className="pjc-summary-icon green">
                  <FaCheckCircle />
                </div>
                <div>
                  <p>Approved Transactions</p>
                  <h3>{summaryApprovedCount}</h3>
                  <small>Verified Remittances</small>
                </div>
              </article>

              

              <article className="pjc-summary-card">
                <div className="pjc-summary-icon blue">
                  <FaMoneyBillWave />
                </div>
                <div>
                  <p>Balance Pledge</p>
                  <h3>{formatMoney(totalPledged)}</h3>
                  <small>Balance Pledged Amount</small>
                </div>

              </article>
                <article className="pjc-summary-card">
                <div className="pjc-summary-icon blue">
                  <FaMoneyBillWave />
                </div>
                <div>
                  <p>Total Fund Collections</p>
                  <h3>{formatMoney(summaryApprovedTotal)}</h3>
                  <small>Approved Alumni Funds</small>
                </div>
              </article>
              
            </div>

            {/* Pending Approvals Table */}
            {activeItem === "Pending Approvals" && isSuperAdmin && (
              <section className="pjc-panel">
                <div className="pjc-panel-heading">
                  <div>
                    <h2>Pending Payment Verification</h2>
                    <p>Verify submitted payment receipts. Approving will credit the corresponding installment.</p>
                  </div>
                  <button className="pjc-icon-button" onClick={fetchAdminData} title="Refresh Records">
                    <FaSync />
                  </button>
                </div>
                <div className="pjc-table-wrap">
                  <table>
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Alumni Name</th>
                        <th>Batch</th>
                        
                        <th>Reference</th>
                        <th>Amount</th>
                        <th>Method</th>
                        <th>Date</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loadingData ? (
                        <tr>
                          <td colSpan={8} className="pjc-empty-cell">
                            Loading pending approvals...
                          </td>
                        </tr>
                      ) : pendingApprovals.length === 0 ? (
                        <tr>
                          <td colSpan={8} className="pjc-empty-cell">
                            No pending payment approvals right now. All submissions are verified!
                          </td>
                        </tr>
                      ) : (
                        pendingApprovals.map((item, index) => (
                          <tr key={item.id}>
                            <td data-label="S.No">{index + 1}</td>
                            <td data-label="Alumni Name">
                              <strong>{item.fullname || item.donor_name || "Alumni User"}</strong>
                            </td>
                            <td data-label="Batch">{item.batch || "N/A"}</td>
                            <td data-label="Reference" className="pjc-reference">
                              {item.transaction_reference || item.reference || `TXN-${item.id}`}
                            </td>
                            <td data-label="Amount">
                              <strong>{formatMoney(item.amount || item.amount_paid)}</strong>
                            </td>
                            <td data-label="Method">{item.payment_mode || item.method}</td>
                            <td data-label="Date">{formatDate(item.payment_date || item.date)}</td>
                            <td data-label="Actions">
                              <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
                                <button
                                  className="pjc-action-btn approve"
                                  type="button"
                                  onClick={() => handleAdminApprove(item)}
                                >
                                  Approve
                                </button>
                                <button
                                  className="pjc-action-btn reject"
                                  type="button"
                                  onClick={() => openRejectPrompt(item)}
                                >
                                  Reject
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </section>
            )}

            {activeItem === "All Transactions" && (
              <section className="pjc-panel">
                <div className="pjc-panel-heading">
                  <div>
                    <h2>All Transactions</h2>
                    <p>Complete historical log of alumni payments across all batches.</p>
                  </div>
                  <button className="pjc-icon-button" onClick={fetchAdminData} title="Refresh Records">
                    <FaSync />
                  </button>
                </div>

                {/* Filter Bar: search, status, batch, branch, fund type, date range */}
                <div className="pjc-filter-toolbar">
                  {/* <div className="pjc-search-bar">
                    <FaSearch />
                    <input
                      type="text"
                      placeholder="Search by alumni name, reference, batch..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div> */}

                  <div className="pjc-filter-group">
                    <div className="pjc-select-wrap">
                      <select
                        className="pjc-filter-select"
                        aria-label="Filter by status"
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}
                      >
                        {STATUS_FILTER_OPTIONS.map((opt) => (
                          <option key={opt} value={opt}>
                            {opt === "All" ? "All Statuses" : opt}
                          </option>
                        ))}
                      </select>
                      <FaChevronDown className="pjc-select-caret" aria-hidden="true" />
                    </div>

                    {/* Batch-wise filter */}
                    <div className="pjc-select-wrap">
                      <select
                        className="pjc-filter-select"
                        aria-label="Filter by batch"
                        value={batchFilter}
                        onChange={(e) => setBatchFilter(e.target.value)}
                      >
                        <option value="All">All Batches</option>
                        {batchOptions.map((opt) => (
                          <option key={opt} value={opt}>
                            {opt}
                          </option>
                        ))}
                      </select>
                      <FaChevronDown className="pjc-select-caret" aria-hidden="true" />
                    </div>

                    {/* Branch-wise filter */}
                    <div className="pjc-select-wrap">
                      <select
                        className="pjc-filter-select"
                        aria-label="Filter by branch"
                        value={branchFilter}
                        onChange={(e) => setBranchFilter(e.target.value)}
                      >
                        <option value="All">All Branches</option>
                        {branchOptions.map((opt) => (
                          <option key={opt} value={opt}>
                            {opt}
                          </option>
                        ))}
                      </select>
                      <FaChevronDown className="pjc-select-caret" aria-hidden="true" />
                    </div>

                    {/* Fund Type filter (Own / CSR) */}
                    <div className="pjc-select-wrap">
                      <select
                        className="pjc-filter-select"
                        aria-label="Filter by fund type"
                        value={fundTypeFilter}
                        onChange={(e) => setFundTypeFilter(e.target.value)}
                      >
                        <option value="All">All Fund Types</option>
                        {fundTypeOptions.map((opt) => (
                          <option key={opt} value={opt}>
                            {opt}
                          </option>
                        ))}
                      </select>
                      <FaChevronDown className="pjc-select-caret" aria-hidden="true" />
                    </div>

                    <div className="pjc-date-field">
                      <label className="pjc-date-field-label" htmlFor="pjc-start-date">
                        Start Date
                      </label>
                      <div className={`pjc-date-filter-wrap ${startDate ? "has-value" : ""}`}>
                        <FaCalendarAlt className="pjc-date-filter-icon" aria-hidden="true" />
                        <input
                          id="pjc-start-date"
                          type="date"
                          className="pjc-filter-date"
                          aria-label="Start date"
                          value={startDate}
                          max={endDate || undefined}
                          onChange={(e) => setStartDate(e.target.value)}
                        />
                        {startDate && (
                          <button
                            type="button"
                            className="pjc-date-clear-btn"
                            onClick={() => setStartDate("")}
                            aria-label="Clear start date"
                          >
                            <FaTimes />
                          </button>
                        )}
                      </div>
                    </div>

                    <div className="pjc-date-field">
                      <label className="pjc-date-field-label" htmlFor="pjc-end-date">
                        End Date
                      </label>
                      <div className={`pjc-date-filter-wrap ${endDate ? "has-value" : ""}`}>
                        <FaCalendarAlt className="pjc-date-filter-icon" aria-hidden="true" />
                        <input
                          id="pjc-end-date"
                          type="date"
                          className="pjc-filter-date"
                          aria-label="End date"
                          value={endDate}
                          min={startDate || undefined}
                          onChange={(e) => setEndDate(e.target.value)}
                        />
                        {endDate && (
                          <button
                            type="button"
                            className="pjc-date-clear-btn"
                            onClick={() => setEndDate("")}
                            aria-label="Clear end date"
                          >
                            <FaTimes />
                          </button>
                        )}
                      </div>
                    </div>

                    {hasActiveFilters && (
                      <button type="button" className="pjc-clear-date-btn" onClick={clearAllFilters}>
                        <FaTimes /> Clear Filters
                      </button>
                    )}
                  </div>
                </div>

                {(startDate || endDate) && (
                  <div className="pjc-active-filter-bar">
                    Showing transactions from
                    {startDate ? <strong> {formatDate(startDate)} </strong> : " the beginning "}
                    {endDate ? "to " : " to present"}
                    {endDate && <strong> {formatDate(endDate)}</strong>}
                    <button type="button" onClick={clearDateFilters}>
                      Clear <FaTimes />
                    </button>
                  </div>
                )}

                <div className="pjc-table-wrap">
                  <table className="pjc-responsive-table">
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Alumni Name</th>
                        <th>Batch</th>
                        <th>Branch</th>
                        <th>Reference </th>
                        <th>Inst</th>
                        <th>Amount</th>
                        <th>Method</th>
                        <th>Date</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loadingData ? (
                        <tr>
                          <td colSpan={10} className="pjc-empty-cell">
                            Loading all transactions...
                          </td>
                        </tr>
                      ) : allTransactions.length === 0 ?  (
                        <tr>
                          <td colSpan={10} className="pjc-empty-cell">
                            {hasActiveFilters
                              ? "No transactions found for the selected filters."
                              : "No transaction records found."}
                          </td>
                        </tr>
                      ) : (
                        paginatedAllTransactions.map((tx, index) => (
                          <tr key={`${tx.source}-${tx.id}`}>
                          <td data-label="S.No">
  {(allTransactionsPage - 1) * RECORDS_PER_PAGE + index + 1}
</td>
                            <td data-label="Alumni Name">
                              <strong>{tx.fullname || tx.donor_name || "Alumni"}</strong>
                            </td>
                            <td data-label="Batch">{tx.batch || "-"}</td>
                            <td data-label="Branch">{tx.branch || "-"}</td>
                            <td data-label="Reference" className="pjc-reference">
                              {tx.reference || `TXN-${tx.id}`}
                            </td>
                            <td data-label="Inst">#{tx.installment_no || "-"}</td>
                            <td data-label="Amount">{formatMoney(tx.amount)}</td>
                            <td data-label="Method">{tx.method}</td>
                            <td data-label="Date">{formatDate(tx.date)}</td>
                            <td data-label="Status">
                              <span className={`pjc-status ${(tx.approval_status || "pending").toLowerCase().replace(/\s+/g, "-")}`}>
                                {tx.approval_status || "PENDING"}
                              </span>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Totals bar for the currently filtered All Transactions table */}
                {!loadingData && (
                  <div
                    className="pjc-table-totals"
                   
                  >

  <span>
    Page Records:{" "}
    <strong>{allTransactionsPageTotals.pageRecords}</strong>
  </span>

  <span>
    Page Total Amount:{" "}
    <strong>{formatMoney(allTransactionsPageTotals.pageTotalAmount)}</strong>
  </span>
                    <span>
                      Records: <strong>{filteredTotals.count}</strong>
                    </span>
                    <span>
                      Total Amount: <strong>{formatMoney(filteredTotals.amount)}</strong>
                    </span>
                  </div>
                )}
                {!loadingData &&
  allTransactions.length > 0 &&
  allTransactionsTotalPages > 1 && (
    <div className="pjc-pagination">
      <button
        type="button"
        className="pjc-pagination-btn"
        disabled={allTransactionsPage === 1}
        onClick={() =>
          setAllTransactionsPage((prev) =>
            Math.max(prev - 1, 1)
          )
        }
      >
        Previous
      </button>

      <div className="pjc-pagination-pages">
        {Array.from(
  { length: allTransactionsTotalPages },
  (_, index) => index + 1
)
  .filter(
    (page) =>
      page === 1 ||
      page === 2 ||
      page === allTransactionsPage ||
      page === allTransactionsPage - 1 ||
      page === allTransactionsPage + 1 ||
      page === allTransactionsTotalPages
  )
  .map((page, index, pages) => (
    <React.Fragment key={page}>
      {index > 0 && page - pages[index - 1] > 1 && (
        <span className="pjc-pagination-dots">...</span>
      )}

      <button
        type="button"
        className={`pjc-pagination-number ${
          allTransactionsPage === page ? "active" : ""
        }`}
        onClick={() => setAllTransactionsPage(page)}
      >
        {page}
      </button>
    </React.Fragment>
  ))}
      </div>

      <button
        type="button"
        className="pjc-pagination-btn"
        disabled={
          allTransactionsPage === allTransactionsTotalPages
        }
        onClick={() =>
          setAllTransactionsPage((prev) =>
            Math.min(prev + 1, allTransactionsTotalPages)
          )
        }
      >
        Next
      </button>
    </div>
  )}
              </section>
            )}

            {activeItem === "Alumni / Users" && (
              <section className="pjc-panel">
                <div className="pjc-panel-heading">
                  <div>
                    <h2>Registered Alumni</h2>
                    <p>Overview of alumni members and their pledged contributions.</p>
                  </div>
                </div>
                <div className="pjc-table-wrap">
                  <table className="pjc-responsive-table">
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Alumni Name</th>
                        <th>Batch / Branch</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Fund Type</th>
                        <th>Total Pledged</th>
                        <th>Total Paid</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loadingData ? (
                        <tr>
                          <td colSpan={8} className="pjc-empty-cell">
                            Loading registered alumni directory...
                          </td>
                        </tr>
                      ) : registeredAlumni.length === 0 ? (
                        <tr>
                          <td colSpan={8} className="pjc-empty-cell">
                            No registered alumni records found.
                          </td>
                        </tr>
                      ) : (
                        registeredAlumni.map((usr, index) => (
                          <tr key={usr.id || usr._id}>
                            <td data-label="S.No">
  {(alumniPage - 1) * RECORDS_PER_PAGE + index + 1}
</td>
                            <td data-label="Alumni Name">
                              <strong>{usr.fullname}</strong>
                            </td>
                            <td data-label="Batch / Branch">
                              {usr.batch ? `${usr.batch} / ${pick(usr, BRANCH_KEYS) || ""}` : "Guest"}
                            </td>
                            <td data-label="Email">{usr.email}</td>
                            <td data-label="Phone">{usr.phone || "-"}</td>
                            <td data-label="Fund Type">{pick(usr, FUND_TYPE_KEYS) || "N/A"}</td>
                            <td data-label="Total Pledged">{formatMoney(usr.total_amount || 0)}</td>
                            <td data-label="Total Paid">{formatMoney(usr.total_paid || 0)}</td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
                
                {alumniTotalPages > 1 && (
  <div className="pjc-pagination">

    <button
      className="pjc-pagination-btn"
      onClick={() =>
        setAlumniPage((prev) => Math.max(prev - 1, 1))
      }
      disabled={alumniPage === 1}
    >
      Previous
    </button>

    <div className="pjc-pagination-pages">
      {Array.from(
        { length: alumniTotalPages },
        (_, index) => index + 1
      ).map((page) => (
        <button
          key={page}
          className={`pjc-pagination-number ${
            alumniPage === page ? "active" : ""
          }`}
          onClick={() => setAlumniPage(page)}
        >
          {page}
        </button>
      ))}
    </div>

    <button
      className="pjc-pagination-btn"
      onClick={() =>
        setAlumniPage((prev) =>
          Math.min(prev + 1, alumniTotalPages)
        )
      }
      disabled={alumniPage === alumniTotalPages}
    >
      Next
    </button>

  </div>
)}
              </section>
            )}
            
{activeItem === "User Transactions" && (
  <section className="pjc-panel">
    <div className="pjc-panel-heading">
      <div>
        <h2>User Transactions</h2>
        <p>Overview of user transactions and payment history.</p>
      </div>

      <button
        className="pjc-icon-button"
        onClick={fetchUserAlumniData}
        title="Refresh Records"
      >
        <FaSync />
      </button>
    </div>

    {/* User Transactions Filters */}
    <div className="pjc-filter-toolbar">
      <div className="pjc-filter-group">

        {/* Status */}
        <div className="pjc-select-wrap">
          <select
            className="pjc-filter-select"
            value={userStatusFilter}
            onChange={(e) => setUserStatusFilter(e.target.value)}
            aria-label="Filter by status"
          >
            {STATUS_FILTER_OPTIONS.map((opt) => (
              <option key={opt} value={opt}>
                {opt === "All" ? "All Statuses" : opt}
              </option>
            ))}
          </select>

          <FaChevronDown className="pjc-select-caret" />
        </div>

        {/* Batch */}
        <div className="pjc-select-wrap">
          <select
            className="pjc-filter-select"
            value={userBatchFilter}
            onChange={(e) => setUserBatchFilter(e.target.value)}
            aria-label="Filter by batch"
          >
            <option value="All">All Batches</option>

            {batchOptions.map((opt) => (
              <option key={opt} value={opt}>
                {opt}
              </option>
            ))}
          </select>

          <FaChevronDown className="pjc-select-caret" />
        </div>

        {/* Branch */}
        <div className="pjc-select-wrap">
          <select
            className="pjc-filter-select"
            value={userBranchFilter}
            onChange={(e) => setUserBranchFilter(e.target.value)}
            aria-label="Filter by branch"
          >
            <option value="All">All Branches</option>

            {branchOptions.map((opt) => (
              <option key={opt} value={opt}>
                {opt}
              </option>
            ))}
          </select>

          <FaChevronDown className="pjc-select-caret" />
        </div>

        {/* Fund Type */}
        <div className="pjc-select-wrap">
          <select
            className="pjc-filter-select"
            value={userFundTypeFilter}
            onChange={(e) => setUserFundTypeFilter(e.target.value)}
            aria-label="Filter by fund type"
          >
            <option value="All">All Fund Types</option>
            <option value="OWN">OWN</option>
            <option value="CSR">CSR</option>
            <option value="INSTITUTION">INSTITUTION</option>
          </select>

          <FaChevronDown className="pjc-select-caret" />
        </div>

        {/* Start Date */}
        <div className="pjc-date-field">
          <label
            className="pjc-date-field-label"
            htmlFor="user-start-date"
          >
            Start Date
          </label>

          <div
            className={`pjc-date-filter-wrap ${
              userStartDate ? "has-value" : ""
            }`}
          >
            <FaCalendarAlt className="pjc-date-filter-icon" />

            <input
              id="user-start-date"
              type="date"
              className="pjc-filter-date"
              value={userStartDate}
              max={userEndDate || undefined}
              onChange={(e) => setUserStartDate(e.target.value)}
            />

            {userStartDate && (
              <button
                type="button"
                className="pjc-date-clear-btn"
                onClick={() => setUserStartDate("")}
              >
                <FaTimes />
              </button>
            )}
          </div>
        </div>

        {/* End Date */}
        <div className="pjc-date-field">
          <label
            className="pjc-date-field-label"
            htmlFor="user-end-date"
          >
            End Date
          </label>

          <div
            className={`pjc-date-filter-wrap ${
              userEndDate ? "has-value" : ""
            }`}
          >
            <FaCalendarAlt className="pjc-date-filter-icon" />

            <input
              id="user-end-date"
              type="date"
              className="pjc-filter-date"
              value={userEndDate}
              min={userStartDate || undefined}
              onChange={(e) => setUserEndDate(e.target.value)}
            />

            {userEndDate && (
              <button
                type="button"
                className="pjc-date-clear-btn"
                onClick={() => setUserEndDate("")}
              >
                <FaTimes />
              </button>
            )}
          </div>
        </div>

        {/* Clear */}
        {(userStatusFilter !== "All" ||
          userBatchFilter !== "All" ||
          userBranchFilter !== "All" ||
          userFundTypeFilter !== "All" ||
          userStartDate ||
          userEndDate) && (
          <button
            type="button"
            className="pjc-clear-date-btn"
            onClick={() => {
              setUserStatusFilter("All");
              setUserBatchFilter("All");
              setUserBranchFilter("All");
              setUserFundTypeFilter("All");
              setUserStartDate("");
              setUserEndDate("");
            }}
          >
            <FaTimes /> Clear Filters
          </button>
        )}
      </div>
    </div>

    {/* User Transactions Table */}
    <div className="pjc-table-wrap">
      <table className="pjc-responsive-table">
        <thead>
          <tr>
            <th>S.NO</th>
            <th>ALUMNI NAME</th>
            <th>BATCH</th>
            <th>BRANCH</th>
            <th>REFERENCE</th>
            <th>INST</th>
            <th>AMOUNT</th>
            <th>METHOD</th>
            <th>DATE</th>
            <th>STATUS</th>
          </tr>
        </thead>

        <tbody>
          {userAlumniDetails.length > 0 ? (
            userAlumniDetails.map((tx, index) => (
              <tr key={tx.id}>
                <td data-label="S.NO">
  {(userTransactionsPage - 1) * 15 + index + 1}
</td>

                <td data-label="ALUMNI NAME">
                  <strong>{tx.fullname || "-"}</strong>
                </td>

                <td data-label="BATCH">
                  {tx.batch || "-"}
                </td>

                <td data-label="BRANCH">
                  {tx.branch || "-"}
                </td>

                <td data-label="REFERENCE">
                  {tx.transaction_reference || "-"}
                </td>

                <td data-label="INST">
                  {tx.installment_no || "-"}
                </td>

                <td data-label="AMOUNT">
                  {formatMoney(tx.amount_paid || tx.amount || 0)}
                </td>

                <td data-label="METHOD">
                  {tx.payment_mode || "-"}
                </td>

                <td data-label="DATE">
                  {tx.payment_date
                    ? formatDate(tx.payment_date)
                    : "-"}
                </td>

                <td data-label="STATUS">
                  <span
                    className={`pjc-status ${
                      (tx.approval_status || "pending")
                        .toLowerCase()
                        .replace(/\s+/g, "-")
                    }`}
                  >
                    {tx.approval_status || "PENDING"}
                  </span>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan="10"
                className="pjc-empty-cell"
              >
                No transactions found for the selected filters.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
<div className="pjc-table-totals">
  <span>
    Page Records:{" "}
    <strong>
      {userTransactionsPageTotals.pageRecords}
    </strong>
  </span>

  <span>
    Page Total Amount:{" "}
    <strong>
      {formatMoney(
        userTransactionsPageTotals.pageTotalAmount
      )}
    </strong>
  </span>

  <span>
    Records:{" "}
    <strong>
      {userTransactionsPagination.totalRecords}
    </strong>
  </span>

  <span>
    Total Amount:{" "}
    <strong>
      {formatMoney(
        userTransactionsTotals.totalAmount
      )}
    </strong>
  </span>
</div>
{!loadingData &&
  userAlumniDetails.length > 0 &&
  userTransactionsTotalPages > 1 && (
    <div className="pjc-pagination">
      <button
        type="button"
        className="pjc-pagination-btn"
        disabled={userTransactionsPage === 1}
        onClick={() =>
          setUserTransactionsPage((prev) =>
            Math.max(prev - 1, 1)
          )
        }
      >
        Previous
      </button>

      <div className="pjc-pagination-pages">
        {Array.from(
          { length: userTransactionsTotalPages },
          (_, index) => index + 1
        )
          .filter(
            (page) =>
              page === 1 ||
              page === 2 ||
              page === userTransactionsPage ||
              page === userTransactionsPage - 1 ||
              page === userTransactionsPage + 1 ||
              page === userTransactionsTotalPages
          )
          .map((page, index, pages) => (
            <React.Fragment key={page}>
              {index > 0 &&
                page - pages[index - 1] > 1 && (
                  <span className="pjc-pagination-dots">
                    ...
                  </span>
                )}

              <button
                type="button"
                className={`pjc-pagination-number ${
                  userTransactionsPage === page ? "active" : ""
                }`}
                onClick={() =>
                  setUserTransactionsPage(page)
                }
              >
                {page}
              </button>
            </React.Fragment>
          ))}
      </div>

      <button
        type="button"
        className="pjc-pagination-btn"
        disabled={
          userTransactionsPage === userTransactionsTotalPages
        }
        onClick={() =>
          setUserTransactionsPage((prev) =>
            Math.min(
              prev + 1,
              userTransactionsTotalPages
            )
          )
        }
      >
        Next
      </button>
    </div>
  )}
    
  
  </section>
)}
{activeItem === "Manual Entry Transactions" && (
  <section className="pjc-panel">
    <div className="pjc-panel-heading">
      <div>
        <h2>Manual Entry Transactions</h2>
        <p>Transactions entered manually by the administrator.</p>
      </div>

      <button
        className="pjc-icon-button"
        onClick={fetchManualEntryData}
        title="Refresh Records"
      >
        <FaSync />
      </button>
    </div>

    <div className="pjc-table-wrap">
      <table className="pjc-responsive-table">
        <thead>
          <tr>
            <th>S.NO</th>
            <th>ALUMNI NAME</th>
            <th>BATCH</th>
            <th>BRANCH</th>
            <th>REFERENCE</th>
            <th>AMOUNT</th>
            <th>METHOD</th>
            <th>DATE</th>
            <th>STATUS</th>
          </tr>
        </thead>

        <tbody>
          {manualEntryDetails.length > 0 ? (
            manualEntryDetails.map((tx, index) => (
              <tr key={tx.id}>
                <td>{(manualEntryPage - 1) * 15 + index + 1}</td>
                <td> <strong>{tx.fullname || "-"}</strong></td>
                <td>{tx.batch || "-"}</td>
                <td>{tx.branch || "-"}</td>
                <td>{tx.transaction_reference || "-"}</td>
                <td>
                  ₹{Number(tx.amount_paid || 0).toLocaleString()}
                </td>
                <td>{tx.payment_mode || "-"}</td>
                <td>
                  {tx.payment_date
                    ? new Date(tx.payment_date).toLocaleDateString()
                    : "-"}
                </td>
                <td>
                  <span
                    className={`pjc-status ${
                      (tx.approval_status || "pending").toLowerCase().replace(/\s+/g, "-")
                    }`}
                  >
                    {tx.approval_status || "PENDING"}
                  </span>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="9" style={{ textAlign: "center" }}>
                No manual entry transactions found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
    <div className="pjc-table-totals">
  <span>
    Page Records:{" "}
    <strong>
      {manualEntryPageTotals.pageRecords}
    </strong>
  </span>

  <span>
    Page Total Amount:{" "}
    <strong>
      {formatMoney(manualEntryPageTotals.pageTotalAmount)}
    </strong>
  </span>

  <span>
    Records:{" "}
    <strong>
      {manualEntryPagination.totalRecords}
    </strong>
  </span>

  <span>
    Total Amount:{" "}
    <strong>
      {formatMoney(manualEntryTotals.totalAmount)}
    </strong>
  </span>
</div>
    {!loadingData &&
  manualEntryDetails.length > 0 &&
  manualEntryTotalPages > 1 && (
    <div className="pjc-pagination">
      <button
        type="button"
        className="pjc-pagination-btn"
        disabled={manualEntryPage === 1}
        onClick={() =>
          setManualEntryPage((prev) =>
            Math.max(prev - 1, 1)
          )
        }
      >
        Previous
      </button>

      <div className="pjc-pagination-pages">
        {Array.from(
          { length: manualEntryTotalPages },
          (_, index) => index + 1
        )
          .filter(
            (page) =>
              page === 1 ||
              page === 2 ||
              page === manualEntryPage ||
              page === manualEntryPage - 1 ||
              page === manualEntryPage + 1 ||
              page === manualEntryTotalPages
          )
          .map((page, index, pages) => (
            <React.Fragment key={page}>
              {index > 0 &&
                page - pages[index - 1] > 1 && (
                  <span className="pjc-pagination-dots">
                    ...
                  </span>
                )}

              <button
                type="button"
                className={`pjc-pagination-number ${
                  manualEntryPage === page ? "active" : ""
                }`}
                onClick={() =>
                  setManualEntryPage(page)
                }
              >
                {page}
              </button>
            </React.Fragment>
          ))}
      </div>

      <button
        type="button"
        className="pjc-pagination-btn"
        disabled={
          manualEntryPage === manualEntryTotalPages
        }
        onClick={() =>
          setManualEntryPage((prev) =>
            Math.min(
              prev + 1,
              manualEntryTotalPages
            )
          )
        }
      >
        Next
      </button>
    </div>
  )}
  </section>
)}



            {activeItem === "Payment Plans" && (
              <section className="pjc-panel pjc-details-panel">
                <div className="pjc-panel-heading">
                  <div>
                    <h2>Payment Plans System</h2>
                    <p>Structured payment plans synced live with user pledges and transactions.</p>
                  </div>
                </div>
                <div style={{ padding: "24px", color: "#62748e", fontSize: "14px" }}>
                  All Contribution schedules and payment plans are generated dynamically upon user registration. Select{" "}
                  <strong>Pending Approvals</strong> or <strong>All Transactions</strong> to process alumni payments.
                </div>
              </section>
            )}
          </section>
        </div>
      </main>
      <Alertmessage message={alertMsg} onClose={() => setAlertMsg("")} />
      <Alertmessage
        type="confirm"
        message={confirmModal?.message}
        onConfirm={confirmModal?.onConfirm}
        onCancel={() => setConfirmModal(null)}
      />
      <Alertmessage
        type="prompt"
        message={rejectPrompt ? "Enter rejection reason for Alumni:" : ""}
        inputValue={rejectPrompt?.reasonValue || ""}
        onInputChange={(e) => setRejectPrompt(prev => ({ ...prev, reasonValue: e.target.value }))}
        onConfirm={handleAdminReject}
        onCancel={() => setRejectPrompt(null)}
      />
    </div>
  );
};

export default AdminDashboard;